import { render, staticRenderFns } from "./DialogAlipay.vue?vue&type=template&id=2923a92f&scoped=true"
import script from "./DialogAlipay.vue?vue&type=script&lang=js"
export * from "./DialogAlipay.vue?vue&type=script&lang=js"
import style0 from "./DialogAlipay.vue?vue&type=style&index=0&id=2923a92f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2923a92f",
  null
  
)

export default component.exports